<div class="delivery-images-page">
  <div class="delivery-content">
    <section class="info-panel">
      <div class="panel-title">Delivery Details</div>
      <div class="info-grid">
        <div class="info-item">
          <div class="label">Asset Id</div>
          <div class="value">{{ deliveryImages?.assetId || '-' }}</div>
        </div>
        <div class="info-item">
          <div class="label">Asset Type</div>
          <div class="value">{{ deliveryImages?.assetType || '-' }}</div>
        </div>
        <div class="info-item wide">
          <div class="label">Delivery Location</div>
          <div class="value">{{ deliveryImages?.deliveryConfirmation?.deliveryLocation || '-' }}</div>
        </div>
        <div class="info-item">
          <div class="label">Delivery Date</div>
          <div class="value">{{ formatDate(deliveryImages?.deliveryConfirmation?.deliveryDate) || '-' }}</div>
        </div>
        <div class="info-item">
          <div class="label">Created</div>
          <div class="value">{{ formatDateAndTime(deliveryImages?.deliveryConfirmation?.created) || '-' }}</div>
        </div>
      </div>
    </section>

    <section class="images-panel">
      <div class="panel-title">Delivery Photographs</div>

      @if (errorMessage) {
        <div class="message error">{{ errorMessage }}</div>
      }
      @if (!errorMessage && !loading && imageLinks.length === 0) {
        <div class="message empty">No delivery photographs found.</div>
      }

      <div class="image-grid">
        @for (image of imageLinks; track image.url) {
          <div class="image-card" (click)="openPopup(image.url)">
            <img [src]="image.url" [alt]="image.label">
            <!-- <div class="caption">{{ image.label }}</div> -->
          </div>
        }
      </div>
    </section>
  </div>
</div>
<app-image-popup [imageSrc]="selectedImage" [isOpen]="isPopupOpen" (close)="closePopup()"></app-image-popup>
